import type { InlineExpandButtonProps } from "@sb1/ffe-buttons-react";
import { getCustomData, transformerTekst } from "~/utils/tracking/utils";
import { InlineExpandButton as FellesInlineExpandButton } from "@sb1f/buttons";

type Props = InlineExpandButtonProps & {
	track?: boolean;
	knappNavn?: string;
	trackData?: object;
};

const InlineExpandButton = ({ track = true, knappNavn, trackData, ...props }: Props) => {
	// props.isExpanded er litt forsinket. Så "lukk" og "les mer" er byttet om.
	const trackedNavn = transformerTekst(`${knappNavn ? knappNavn : props["aria-controls"]}_${props.isExpanded ? "lukk" : "les_mer"}`);
	const customData = trackData ? { ...trackData, ...getCustomData() } : getCustomData();
	return <FellesInlineExpandButton knappNavn={trackedNavn} customData={customData} {...props} />;
};

export default InlineExpandButton;
